import * as yup from 'yup';

export const VALIDATIONS = {
  email: yup
    .string()
    .required('Email required!')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email!',
    ),
  password: yup.string().required('Password is required!'),
  confirmPassword: yup
    .string()
    .label('confirm password')
    .required()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
  username: yup
    .string()
    .required('Username is required!')
    .matches(/^[^0-9]/, "Your username can't start with a number")
    .matches(/^(?!.*\d_)(?!.*_d)[a-zA-Z0-9_]+$/, 'Only letters, numbers and _ are allowed')
    .min(3, 'Slug should be at least 3 characters long')
    .ensure(),
  confirmPass: yup
    .string()
    .label('confirm password')
    .required()
    .oneOf([yup.ref('newPass'), null], 'Passwords must match'),
  firstname: yup.string().required('First name is required'),
  lastname: yup.string().required('Last name is required'),
  fullname: yup.string().required('Full name is required'),
  displayname: yup.string().required('Display name is required'),
  dob: yup.date().required('DOB is Required'),
  country: yup.string().required('Country is required'),
  applicableTitles: yup
    .array()
    .of(yup.string().required('Applicable titles are required'))
    .min(1, 'Please choose at least 1 applicable title')
    .max(5, 'You can only choose 5 applicable titles')
    .required('Choose a minimum of 1 applicable title and a maximum of 3'),
  avatar: yup.mixed().required('Avatar is required'),
  image: yup.string().required('Image is required'),
  cover_image: yup.string().optional(),
  name: yup.string().required('Name is required'),
  product_name: yup.string().required('Product name is required'),
  class_name: yup.string().required('Class name is required'),
  price: yup
    .number()
    .required('Discount price is required')
    .min(0, 'Discount price should not be less than 0'),
  actual_price: yup
    .number()
    .required('Actual price is required')
    .min(1, 'Actual price must not be less than 1'),
  seat: yup.number().integer().min(1).moreThan(0),
  description: yup.string().required('Description is required'),
  bio: yup.string().required('Bio is required'),
  link: yup.string().url().required('Meeting link is required'),
  venue: yup.string().required('Venue is required'),
  file: yup.string().required('Product must not be empty'),
  facebook_pixel_code: yup.string().required('Enter a facebook pixel code'),
  convertkit_key: yup.string().required('Enter your convertkit api key'),
  address: yup.string().required('Address is required'),
  zip_code: yup.string().required('Zip code is required'),
  generic: yup.string().required('Field is required'),
  phone_number: yup.string().min(8).required('Please enter a valid phone number'),
};

export function containsSpecialChars(str: string) {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; //eslint-disable-line
  return specialChars.test(str);
}

export const createPasswordValidation = () => {
  return yup.object({
    password: yup.string().when('page', {
      is: 1,
      then: yup
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(24, 'Password cannot exceed 24 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/\d/, 'Password must contain at least one number')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one symbol')
        .required('Password is required'),
      otherwise: yup.string().notRequired(),
    }),
    confirmPassword: yup.string().when('page', {
      is: 1,
      then: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required'),
      otherwise: yup.string().notRequired(),
    }),
    securityQuestion: yup.string().when('page', {
      is: 2,
      then: yup.string().required('Security question is required'),
      otherwise: yup.string().notRequired(),
    }),
    securityAnswer: yup.string().when('page', {
      is: 2,
      then: yup.string().required('Security answer is required'),
      otherwise: yup.string().notRequired(),
    }),
  });
};
